var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMondayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1057_3157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0718 38.0026C22.0425 37.953 20.3682 37.0578 19.2991 35.1891C18.2033 33.2574 18.251 31.28 19.4194 29.396C22.2009 24.9124 25.0187 20.4535 27.8193 15.9832C28.392 15.0689 28.9514 14.1413 29.5508 13.2441C30.3466 12.0171 31.5901 11.1492 33.0163 10.8251C34.4426 10.501 35.9391 10.7464 37.1871 11.5091C39.8236 13.1334 40.7056 16.5119 39.0638 19.1746C35.7076 24.64 32.3037 30.0787 28.8521 35.4907C27.7888 37.1647 26.1756 37.9721 24.0718 38.0026Z",
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6425 38.0025C4.59406 37.9529 2.92935 37.0176 1.88127 35.1566C0.800734 33.2249 0.86946 31.2436 2.04163 29.3597C5.03378 24.5598 8.0393 19.7669 11.0582 14.981C11.44 14.3626 11.8218 13.7289 12.2304 13.1296C13.0588 11.9292 14.3219 11.0983 15.7524 10.8127C17.1828 10.5272 18.6683 10.8095 19.8942 11.5999C21.1201 12.3902 21.9903 13.6266 22.3204 15.0472C22.6506 16.4677 22.4148 17.961 21.6631 19.2108C18.3184 24.6107 14.9279 29.9915 11.5354 35.3666C10.4339 37.1092 8.81311 37.972 6.6425 38.0025Z",
    fill: "#FF3D57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6146 27.0577C44.7015 27.073 47.2005 29.5257 47.1948 32.5339C47.1948 35.588 44.629 38.0502 41.5134 38.0121C38.3978 37.9739 35.9427 35.5479 35.9465 32.5263C35.9504 29.4609 38.4589 27.0386 41.6146 27.0577Z",
    fill: "#00D647"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1057_3157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.4,
    height: 28.7447,
    fill: "white",
    transform: "translate(0.800049 9.6001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMondayIcon);
export default __webpack_public_path__ + "static/media/monday-icon.2cb069cba024bcc21a55a22a5535692d.svg";
export { ForwardRef as ReactComponent };